import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from 'features/core/shared/widget/widget-data';
import {WidgetDataParam} from 'features/core/shared/widget/widget-data-param';
import {WidgetFactory} from 'features/core/shared/widget/service/widget.factory';

/**
 * navItem "Basisdaten" of the ProvisionType object component, widget alias
 * `cp.provisionType.base.form`.
 *
 * FORM MECHANISM (rule H4, skill fe_core_form): METADATA DRIVEN, no hand-written Angular form.
 * `WidgetFactory.createWidgetObject(...)` builds an object widget whose runtime implementation
 * `mvs-widget-object` internally renders exactly ONE `<mvs-crud-object>`
 * (`features/core/shared/widget/component/runtime/implementations/mvs-widget-object/
 * mvs-widget-object.component.html:3`). The form template comes from the backend FormObject of the
 * alias `cp.ProvisionType`; no field whitelist is applied here because every attribute of the
 * master record (alias, entityStatus, lookbackYears, payoutTransactionType, description) is
 * relevant.
 *
 * In-module precedent: `../../../cp-provision-agent-object/shared/cp-provision-agent-base-data/`.
 */
@Component({
    selector: 'cp-provision-type-base-data',
    templateUrl: './cp-provision-type-base-data.component.html',
    styleUrls: ['./cp-provision-type-base-data.component.scss'],
    standalone: false
})
export class CpProvisionTypeBaseDataComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;
    initialized: boolean;

    @Input() provisionTypeId: number;

    baseFormWidget: WidgetData;

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshComponent();
    }

    refreshComponent(): void {

        if (!this.provisionTypeId) {
            this.baseFormWidget = null;
            this.initialized = true;
            return;
        }

        /**
         * AI:
         * Status: "in progress"
         * Type: Widget
         * SubType: Configuration
         * Reason: Object widget (mvs-crud-object) with the master form of the provision type.
         *     Source: backend FormObject of alias cp.ProvisionType, mode update.
         *     The lookback period and the payout booking type are maintained here.
         */
        this.baseFormWidget = WidgetFactory.createWidgetObject(
            'cp.provisionType.base.form',
            'Stammdaten',
            'cp.ProvisionType',
            this.provisionTypeId,
            WidgetDataParam.create('size', 'S')
        );

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['provisionTypeId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }

}
